import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ClientStatusService, DialogService, DictionaryEntry, PagedContentConfiguration, PagedContentType, SelectFieldOption, TranslationService } from '@sdbn/common';
import { TransortOptionParameterValue, TransportOption, TransportOptionParameter } from '../../transport-options.model';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-transport-option-editor-parameter',
  templateUrl: './transport-option-editor-parameter.component.html',
  styleUrls: ['./transport-option-editor-parameter.component.scss'],
  standalone: false
})
export class TransportOptionEditorParameterComponent implements OnInit {


  data = [];
  configuration = new PagedContentConfiguration({
    columns: [],
    itemDataAccessor: {
      getTitle: (item: any) => item['name'].getValue(this.translationService.language)?.value,
      getSubtitle: (item: any) => undefined,
      getIcon: (item: any) => undefined
    },
    desktopType: PagedContentType.SIDE_TAB_SINGLE,
    mobileType: PagedContentType.ICON_MENU_SINGLE
  });

  transportOption: TransportOption;
  @Input('transportOption') set setTransportOption(transportOption: TransportOption) {
    this.transportOption = transportOption;
    this.currentTransportOptionParameter = transportOption.parameter.length > 0 ? transportOption.parameter[0] : undefined;
  }

  currentTransportOptionParameter: TransportOptionParameter | undefined;

  formGroup = new FormGroup({
    type: new FormControl(null, []),
    sortOrder: new FormControl(null, []),
    minLength: new FormControl(null, []),
    showInTerminal: new FormControl(false, []),
    mandatoryInTerminal: new FormControl(false, []),
    showInTime: new FormControl(false, []),
    mandatoryInTime: new FormControl(false, []),
  });

  options: Array<SelectFieldOption> = [
    new SelectFieldOption({ value: 'TEXT', labelDictionaryKey: 'tmc-yard.control.common.enum.transport-option-parameter-type.TEXT' }),
    new SelectFieldOption({ value: 'SINGLE_SELECT', labelDictionaryKey: 'tmc-yard.control.common.enum.transport-option-parameter-type.SINGLE_SELECT' }),
    new SelectFieldOption({ value: 'MULTI_SELECT', labelDictionaryKey: 'tmc-yard.control.common.enum.transport-option-parameter-type.MULTI_SELECT' }),
  ];
  // legacy

  @Output() changed = new EventEmitter();

  currentEditingParameterValue: TransortOptionParameterValue | undefined;

  constructor(
    private translationService: TranslationService,
    private dialogService: DialogService,
    public clientStatusService: ClientStatusService
  ) {
  }

  public onSelectionChanged(parameter: any) {
    console.log('on selection changed', parameter, this.currentTransportOptionParameter == parameter);
    this.currentTransportOptionParameter = parameter;
    this.formGroup.patchValue({
      type: parameter?.type,
      minLength: parameter?.minLength,
      sortOrder: parameter?.sortOrder,
      showInTerminal: parameter?.showInTerminal,
      mandatoryInTerminal: parameter?.mandatoryInTerminal,
      showInTime: parameter?.showInTime,
      mandatoryInTime: parameter?.mandatoryInTime
    });
  }

  public onAddParameter(parameter: any) {
    console.log('on add attribute', parameter, this.currentTransportOptionParameter);
    const newParameter = new TransportOptionParameter();
    newParameter.name = new DictionaryEntry();
    newParameter.name.values.push({ language: this.translationService.language, value: 'New Parameter ' + (this.transportOption.parameter.length + 1) });
    this.currentTransportOptionParameter = newParameter;
    this.transportOption.parameter = new Array(...this.transportOption.parameter, newParameter);
    // this.transportOptionParameterSelection = newParameter;
    console.log('parameters are', this.transportOption.parameter);
  }

  public onDeleteParameter(parameter: any) {
    console.log('on delete parameter', parameter, this.currentTransportOptionParameter);
    this.dialogService.showConfirm('tmc-yard.control.ui.transport-option-administration.delete-parameter-title', 'tmc-yard.control.ui.transport-option-administration.delete-parameter-message').afterClosed().subscribe(result => {
      if (result) {
        if (this.transportOption.parameter.indexOf(parameter) > -1) {
          this.transportOption.parameter.splice(this.transportOption.parameter.indexOf(parameter), 1);
        }
        this.currentTransportOptionParameter = undefined;
      }
    });
  }

  public ngOnInit() {
    this.formGroup.valueChanges.subscribe(value => {
      console.log('form value changed', value, this.currentTransportOptionParameter);
      if (this.currentTransportOptionParameter) {
        console.log('setting parameter type to', value.type);
        this.currentTransportOptionParameter.type = value.type || undefined;
        this.currentTransportOptionParameter.minLength = value.minLength || undefined;
        this.currentTransportOptionParameter.showInTerminal = value.showInTerminal || undefined;
        this.currentTransportOptionParameter.mandatoryInTerminal = value.mandatoryInTerminal || undefined;
        this.currentTransportOptionParameter.showInTime = value.showInTime || undefined;
        this.currentTransportOptionParameter.mandatoryInTime = value.mandatoryInTime || undefined;
        this.currentTransportOptionParameter.sortOrder = value.sortOrder || undefined;
      }
    });
  }

  onParameterNameChanged(entry: DictionaryEntry) {
    if (this.currentTransportOptionParameter == null) {
      return;
    }
    this.currentTransportOptionParameter.name = entry;
  }

  onParameterValueChanged(entry: DictionaryEntry) {
    if (this.currentEditingParameterValue == null) {
      return;
    }
    this.currentEditingParameterValue.value = entry;
  }

  addParameterValue() {

    if (this.currentTransportOptionParameter == null) {
      return;
    }

    let nextId = 0;

    for (const v of this.currentTransportOptionParameter!.values) {
      if (v.id < nextId) {
        nextId = v.id;
      }
    }
    nextId--;

    const value = new TransortOptionParameterValue({ id: nextId });
    this.currentTransportOptionParameter!.values.push(value);
    this.currentEditingParameterValue = value;
  }

  editParameterValue(value: TransortOptionParameterValue) {
    this.currentEditingParameterValue = value;
  }

  deleteParameterValue(value: TransortOptionParameterValue) {

    if (this.currentTransportOptionParameter) {
      if (this.currentTransportOptionParameter.values.indexOf(value) > -1) {
        this.currentTransportOptionParameter.values.splice(this.currentTransportOptionParameter.values.indexOf(value), 1);
      }
    }
  }

  unselectParameterValue() {
    this.currentEditingParameterValue = undefined;
  }
}
